import type { Message } from '../../types/mfc'
import { getRoomsState, setRoomMessagesState } from '../app-state/state.rooms'
import { PurchaseInfoResponse } from '../mfcLogic/tokenPurchaseOptions'
import { PMSTATE, setPMChatTextState } from '../state/state.pm'
import { slugToID } from '../state/state.users'

type ILocation = {
    location: {
        type: string
        slug: string
    }
}

type InChatQuickBuyDialogProps = PurchaseInfoResponse & ILocation

export const inChatQuickBuyDialog = (payload: InChatQuickBuyDialogProps) => {
    if (!payload) return
    const {
        success = false,
        products,
        processors,
        available_quickbuy_processors,
        disable_in_chat_quickbuy,
        processor_priority,
        location: { type, slug } = {},
    } = payload
    const id = slugToID[slug]
    if (!id) return
    if (
        success &&
        available_quickbuy_processors.length > 0 &&
        disable_in_chat_quickbuy === 0
    ) {
        const priorityProcessor = processor_priority.find((processor) =>
            available_quickbuy_processors.includes(processor),
        )
        const productMessages = Object.values(products).map(
            (product: any) => ` {{QuickBuy|${product.volume}}} `,
        )
        const quickBuyAdMsg: Message = {
            system: true,
            timestamp: Date.now(),
            text: `QuickBuy: ${productMessages
                .slice(0, -1)
                .join(', ')}, or ${productMessages.slice(-1)}\t tokens via ${
                processors[priorityProcessor].name
            }`,
        }
        const messages = PMSTATE.chats
        const rooms = getRoomsState()
        if (!slug) {
            Object.keys(rooms).forEach((roomId) => {
                setRoomMessagesState(quickBuyAdMsg, Number(roomId))
            })
            Object.keys(messages).forEach((id) => {
                setPMChatTextState(Number(id), quickBuyAdMsg)
            })
        } else {
            if (type === 'message') {
                const { [slugToID[slug]]: messageState } = messages
                if (messageState) {
                    setPMChatTextState(Number(id), quickBuyAdMsg)
                }
            } else if (type === 'room') {
                const { [id]: roomState } = getRoomsState()
                if (roomState) {
                    setRoomMessagesState(quickBuyAdMsg, id)
                }
            }
        }
    }
}
